module.exports = {
  confirmation: {
    emailConfirmationCodeLength: 6,
    twofaConfirmationCodeLength: 6
  },
  colorTheme: {
    AUDT: 'audt.to',
    TIMEX: 'timex.io'
  }
}
